import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
// import ChatWidget from '../../components/ChatWidget/ChatWidget';
import styles from './DashboardLayout.module.scss';

const DashboardLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      <div className={styles.layout}>
        {children}
      </div>
      {/* <ChatWidget /> */}
    </>
  );
};

export default DashboardLayout;
